"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function epoqConfig() {
    var _a, _b, _c, _d, _e, _f, _g;
    return {
        customerId: (_b = (_a = window.flowConfig) === null || _a === void 0 ? void 0 : _a.customerId) !== null && _b !== void 0 ? _b : window.epoq_customerId,
        sessionId: (_e = (_d = (_c = window.flowConfig) === null || _c === void 0 ? void 0 : _c.sessionId) !== null && _d !== void 0 ? _d : window.getEpoq_sessionId()) !== null && _e !== void 0 ? _e : "1",
        tenantId: (_g = (_f = window.flowConfig) === null || _f === void 0 ? void 0 : _f.tenantId) !== null && _g !== void 0 ? _g : window.epoq_tenantId,
    };
}
exports.default = epoqConfig;
